import { render, staticRenderFns } from "./AddressCard.vue?vue&type=template&id=336a50d1"
import script from "./AddressCard.vue?vue&type=script&lang=js"
export * from "./AddressCard.vue?vue&type=script&lang=js"
import style0 from "./AddressCard.vue?vue&type=style&index=0&id=336a50d1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports